import React from 'react'
import { AccordionProps } from '@mui/material';
import ModalQuoteHistory from './modalQuoteHistory/modalQuoteHistory';
import { ExpandMore } from '@mui/icons-material';
import { getTranslateByKey, isNullUndefined } from '@/main/services/utils';
import * as S from './styles';

interface IAccordionQuoteHistoryProps {
  isCollapse?: boolean;
  guidQuote: string | null;
  showPrices?: boolean;
  guidScreen?: string;
  name?: string;
  propsCollapse?: Omit<AccordionProps, 'children'>;
}

function AccordionQuoteHistory({
  isCollapse = false,
  showPrices = true,
  guidQuote,
  guidScreen,
  name,
  propsCollapse = {}
}: IAccordionQuoteHistoryProps) {
  const nameColapse = isNullUndefined(name) ? '' : ` - ${name}`
  return (
    <S.AccordionHistoryStyle {...(!isCollapse && { expanded: true })} {...propsCollapse}>
      <S.AccordionSummaryHistory expandIcon={isCollapse ? <ExpandMore /> : <></>}>
        <S.AccordionTitle>{getTranslateByKey('information.quote')} {nameColapse}</S.AccordionTitle>
      </S.AccordionSummaryHistory>
      <S.AccordionDetailsHistory>
        <ModalQuoteHistory
          guidQuote={guidQuote}
          showPrices={showPrices}
          guidScreen={guidScreen}
        />
      </S.AccordionDetailsHistory>
    </S.AccordionHistoryStyle>
  )
}

export default AccordionQuoteHistory